module.exports = __webpack_public_path__ + "img/airport.00e9958d.png";